import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LibraryFilesState {
    isLoadingWorksheets: boolean;
    isLoadingStudyMaterials: boolean;
    worksheets: any[];
    studyMaterials: any[];
    error: any;
}

const initialState: LibraryFilesState = {
    isLoadingWorksheets: false,
    isLoadingStudyMaterials: false,
    worksheets: [],
    studyMaterials: [],
    error: null,
};

const LibraryFilesSlice = createSlice({
    name: "LibraryFiles",
    initialState,
    reducers: {
        getWorksheetsAction: (state, action: PayloadAction<string>) => {
            state.isLoadingWorksheets = true;
        },
        getStudyMaterialsAction: (state, action: PayloadAction<string>) => {
            state.isLoadingStudyMaterials = true;
        },
        successGetWorksheets: (state, action: PayloadAction<any[]>) => {
            state.isLoadingWorksheets = false;
            state.worksheets = action.payload;
        },
        successGetStudyMaterials: (state, action: PayloadAction<any[]>) => {
            state.isLoadingStudyMaterials = false;
            state.studyMaterials = action.payload;
        },
        failureGetLibraryFiles: (state, action: PayloadAction<any>) => {
            state.isLoadingWorksheets = false;
            state.isLoadingStudyMaterials = false;
            state.error = action.payload;
        },
        clearLibraryFiles: (state) => {
            state.worksheets = [];
            state.studyMaterials = [];
            state.error = null;
        }
    },
});

export const {
    getWorksheetsAction,
    getStudyMaterialsAction,
    successGetWorksheets,
    successGetStudyMaterials,
    failureGetLibraryFiles,
    clearLibraryFiles,
} = LibraryFilesSlice.actions;

export default LibraryFilesSlice.reducer;
